var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFeatherLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.637,
    height: 13.215,
    viewBox: "0 0 12.637 13.215",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-lock",
    "data-name": "Icon feather-lock",
    transform: "translate(0.85 0.85)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_470",
    "data-name": "Path 470",
    d: "M5.715,16.5h8.507a1.185,1.185,0,0,1,1.215,1.152v4.03a1.185,1.185,0,0,1-1.215,1.152H5.715A1.185,1.185,0,0,1,4.5,21.682v-4.03A1.185,1.185,0,0,1,5.715,16.5Z",
    transform: "translate(-4.5 -11.318)",
    fill: "none",
    stroke: "#2ec193",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_471",
    "data-name": "Path 471",
    d: "M10.5,8.182v-2.3A2.962,2.962,0,0,1,13.538,3a2.962,2.962,0,0,1,3.038,2.879v2.3",
    transform: "translate(-8.069 -3)",
    fill: "none",
    stroke: "#2ec193",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.7
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFeatherLock);
export default __webpack_public_path__ + "static/media/IconFeatherLock.22986d1fe68c0c2dfb8c8b73657e2401.svg";
export { ForwardRef as ReactComponent };